import { render, staticRenderFns } from "./DepartmentsSelect.vue?vue&type=template&id=15eb7544&"
import script from "./DepartmentsSelect.vue?vue&type=script&lang=js&"
export * from "./DepartmentsSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports